import React from 'react';
import './app.css';
import FFBaseAndFreespins from './components/ff-base-and-freespins';
import FF001StarstruckLines from './components/ff001-starstruck-lines';
import FF002Carnival from './components/ff002-carnival';
import FF008Egypt from './components/ff008-egypt';
import FF029Farm from './components/ff029-farm';
import FF029Farm2 from './components/ff029-farm-2';
import FF010BreakingWays from './components/ff010-breaking-ways';
import FF027Arabian from './components/ff027-arabian';
import FF033VaultReveal from './components/ff033-vault-reveal';
import FF034ColorCoins from './components/ff034-color-coins';
import FF035CascadeRainbow from './components/ff035-cascade-rainbow';
import FF035CascadeRainbow2 from './components/ff035-cascade-rainbow-2';
import FF036JokerPsycho from './components/ff036-joker-psycho';
import FF037PurryNights from './components/ff037-purry-nights';
import FF03715Lines from './components/ff037-15-lines';
import FF038GoldenGoat from './components/ff038-golden-goat';
import Login from './components/login/login';
import Home from './components/home/home';
import * as request from 'superagent'; 
import {
  createHashRouter,
  RouterProvider,
  useLocation,
} from "react-router-dom";

function CatchAllFF002Carnival() {
  const location = useLocation();
  const rawPath = location.pathname.replace(/^\/+/, '');
  const modelId = rawPath.split('/')[0];
  return <FF002Carnival modelId={modelId} />;
}

export const buildScenarioRoutes = () => [
  { path: '/', element: <Home /> },
  { path: 'ff001-starstruck', element: <FF001StarstruckLines modelId={'ff001-starstruck'} /> },
  { path: 'ff001-starstruck-lines', element: <FF001StarstruckLines modelId={`ff001-starstruck-lines`} /> },
  { path: 'ff002-carnival', element: <FF002Carnival modelId={`ff002-carnival`} /> },
  { path: 'ff003-viking', element: <FF002Carnival modelId={`ff003-viking`} /> },
  { path: 'ff004-china', element: <FF002Carnival modelId={`ff004-china`} /> },
  { path: 'ff005-mexico', element: <FF002Carnival modelId={`ff005-mexico`} /> },
  { path: 'ff006-retro-future', element: <FF002Carnival modelId={`ff006-retro-future`} /> },
  { path: 'ff007-greek', element: <FF002Carnival modelId={`ff007-greek`} /> },
  { path: 'ff008-egypt', element: <FF008Egypt modelId={`ff008-egypt`} /> },
  { path: 'ff009-mad-scientist', element: <FF002Carnival modelId={`ff009-mad-scientist`} /> },
  { path: 'ff010-breaking-ways', element: <FF010BreakingWays modelId={`ff010-breaking-ways`} /> },
  { path: 'ff010-breaking-ways-2', element: <FF010BreakingWays modelId={`ff010-breaking-ways-2`} /> },
  { path: 'ff011-breaking-buffalo', element: <FF010BreakingWays modelId={`ff011-breaking-buffalo`} /> },
  { path: 'ff011-breaking-buffalo-2', element: <FF010BreakingWays modelId={`ff011-breaking-buffalo-2`} /> },
  { path: 'ff012-iron-horse', element: <FF002Carnival modelId={`ff012-iron-horse`} /> },
  { path: 'ff013-santa', element: <FF002Carnival modelId={`ff013-santa`} /> },
  { path: 'ff014-new-year', element: <FF001StarstruckLines modelId={`ff014-new-year`} /> },
  { path: 'ff020-samurai', element: <FFBaseAndFreespins modelId={`ff020-samurai`} /> },
  { path: 'ff027-arabian', element: <FF027Arabian modelId={`ff027-arabian`} /> },
  { path: 'ff029-farm-2', element: <FF029Farm2 modelId="ff029-farm-2" /> },
  { path: 'ff029-farm', element: <FF029Farm modelId={`ff029-farm`} /> },
  { path: 'ff033-vault-reveal', element: <FF033VaultReveal modelId={`ff033-vault-reveal`} /> },
  { path: 'ff034-color-coins', element: <FF034ColorCoins modelId={`ff034-color-coins`} /> },
  { path: 'ff035-cascade-rainbow', element: <FF035CascadeRainbow modelId={`ff035-cascade-rainbow`} /> },
  { path: 'ff035-cascade-rainbow-2', element: <FF035CascadeRainbow2 modelId={`ff035-cascade-rainbow-2`} /> },
  { path: 'ff036-joker-psycho', element: <FF036JokerPsycho modelId={`ff036-joker-psycho`} /> },
  { path: 'ff037-15-lines', element: <FF03715Lines modelId={`ff037-15-lines`} /> },
  { path: 'ff037-purry-nights', element: <FF037PurryNights modelId={`ff037-purry-nights`} /> },
  { path: 'ff038-golden-goat', element: <FF038GoldenGoat modelId="ff038-golden-goat" /> },
  { path: '*', element: <CatchAllFF002Carnival /> },
];

function App() {
  const [checking, setChecking] = React.useState(true);
  const [loggedIn, setLoggedIn] = React.useState(false);

  const router = createHashRouter(buildScenarioRoutes());
  const init = async () => {
    const res = (await request.post(`${process.env.REACT_APP_API_URL}/n/slots/scenario/login`).withCredentials().send({cookiecheck: true}))?.body;
    setChecking(false);
    if (!res.success) { return; }
    setLoggedIn(!!res.success);
  }
  React.useEffect(() => {
    init();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return checking ? <>Loading</> : (
    <div className="app">
      {!loggedIn 
        ? <Login onLoggedIn={() => setLoggedIn(true)} />
        : <> 
          <RouterProvider router={router} />
        </> }
    </div>
  );
}

export default App;
